import React from "react";
import { Eyebrow } from "@/components/Section";

export const NAVY = "#1A4D6E";
export const CYAN = "#1DA9DA";
export const LIME = "#A4C539";
export const INK = "#101923";
export const LIGHT = "#F5F7F8";
export const RED = "#E11D48";
export const AMBER = "#F59E0B";

export const ExplainerSection = ({ eyebrow, titleA, titleB, intro, items, testId, cols = 2 }) => (
  <section className="bg-white border-y border-line" data-testid={testId}>
    <div className="max-w-7xl mx-auto px-6 sm:px-12 py-24 sm:py-32">
      <div className="max-w-3xl">
        <Eyebrow>{eyebrow}</Eyebrow>
        <h2 className="mt-6 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tightest leading-[1.02] text-ink">
          {titleA}
          <br />
          <span className="text-primary">{titleB}</span>
        </h2>
        <p className="mt-6 text-muted text-lg leading-relaxed max-w-2xl">{intro}</p>
      </div>

      <div className={`mt-16 grid grid-cols-1 md:grid-cols-2 ${cols === 3 ? "lg:grid-cols-3" : ""} gap-6`}>
        {items.map((e) => (
          <article
            key={e.step}
            data-testid={`${testId}-${e.testId}`}
            className="border border-line bg-white overflow-hidden lift"
          >
            <div className="bg-soft border-b border-line">
              <e.illu />
            </div>
            <div className="p-7">
              <div className="flex items-center gap-3">
                <span className="font-display font-black text-3xl text-accent">{e.step}</span>
                <h3 className="font-display font-bold text-xl text-ink leading-tight">{e.title}</h3>
              </div>
              <p className="mt-4 text-muted text-sm leading-relaxed">{e.desc}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
